import React from 'react';
import { IconProps } from '../interfaces';

const SVG = ({
  fill = 'none',
  width = '364',
  height = '72',
  viewBox = '0 0 364 72',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Azura">
      <g id="Logo">
        <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.137 47.4348L137.958 26.3755L147.865 47.4348H128.137ZM103.619 70.8105H117.205L122.529 59.1117H153.357L158.861 70.8105H172.963L138.243 0L103.619 70.8105Z"
          fill="#1e2023"
        />
        <path
          id="Fill 2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M275.977 70.8104H288.14V31.9024H308.075V20.2266H275.977V70.8104Z"
          fill="#1e2023"
        />
        <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M336.339 60.1759C328.376 60.1759 322.198 53.6139 322.198 45.518C322.198 37.4232 328.376 30.8611 336.339 30.8611C344.302 30.8611 350.203 37.4232 350.203 45.518C350.203 53.6139 344.302 60.1759 336.339 60.1759ZM349.861 20.2266V25.4291C346.328 21.5966 340.929 19.0371 334.678 19.0371C320.293 19.0371 309.408 30.8924 309.408 45.518C309.408 60.1436 320.293 71.9999 334.678 71.9999C340.591 71.9999 346.199 69.7858 349.861 66.0535V70.8105H362.025V20.2266H349.861Z"
          fill="#1e2023"
        />
        <path
          id="Fill 4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M211.795 20.2266H170.858V31.9024H193.332L174.527 70.8104L214.009 70.7875V59.1116H193.002L211.795 20.2266Z"
          fill="#1e2023"
        />
        <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M253.887 49.4527C253.887 54.8899 249.638 60.1686 242.805 60.1686C236.028 60.1686 232.001 54.8899 232.001 49.4527V20.2266H219.591V50.0307C219.591 62.4829 229.56 71.9999 242.805 71.9999C255.984 71.9999 266.019 62.4829 266.019 50.0307V20.2266H253.887V49.4527Z"
          fill="#1e2023"
        />
      </g>
      <path
        id="Fill 16"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.8115 35.3573L0.00104342 0V14.4764L11.6998 19.9136V50.1863L0 55.8062V70.8105L70.8115 35.3573Z"
        fill="#1e2023"
      />
    </g>
  </svg>
);
export default SVG;
